import { AxiosInstance } from 'axios'
import { useQuery } from 'react-query'

import { BasicTeam } from '@dc-shared-web/hooks/api/team/types'
import { TEAMS_BASE_QUERY_KEY } from '@dc-shared-web/hooks/api/team/constants'

import { useAuth } from '@dc-shared-web/providers/AuthProvider'
import { useAxiosContext } from '@dc-shared-web/providers/AxiosProvider'

type GetTeamsQueryParams = {
  status?: string
  q?: string
}

const fetchTeams = async (
  apiClient: AxiosInstance,
  params?: GetTeamsQueryParams
): Promise<BasicTeam[]> => {
  const allTeamsText = 'All Teams'

  const {
    data: { results },
  } = await apiClient.get(`/ajax/offices/find`, {
    params,
  })

  if (
    !params?.q ||
    allTeamsText.toLowerCase().includes(params.q.toLowerCase())
  ) {
    return [
      {
        id: 0,
        text: allTeamsText,
      },
      ...results,
    ]
  }

  return results
}

/**
 * Custom hook to fetch minimal team info based on the provided query parameters.
 *
 * @param params - Optional query parameters for fetching teams.
 * @returns The result of the query, containing an array of teams or an error.
 */
export const useGetTeams = (params?: GetTeamsQueryParams) => {
  const { user } = useAuth()
  const apiClient = useAxiosContext()

  return useQuery<BasicTeam[], Error>(
    [TEAMS_BASE_QUERY_KEY, params],
    () => fetchTeams(apiClient, params),
    { enabled: user.is_super_admin }
  )
}
